<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar color-sidebar-white" :class="!showSidebar ? 'collapse-sidebar' : ''">
    
    <div class="sidebar-profile" v-if="showSidebar" style="background:transparent !important;">
      <div class="row">
        <div class="col-3">
          
            <img
              class="avatar"
              src="../../assets/images/users/profile.jpg"
              alt="user"
              style="width: 42px !important;"
            />
          
        </div>
        <div class="col-9">
          <a href="#/profile">
            <b> BKPSDM PKA</b>
            <p>pka.bkpsdm@bogorkab.go.id</p>
          </a>
        </div>
      </div>
    </div>
 
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-small-cap"> <span> Dashboard </span></li>
          <li> 
            <a href="#/diklat"> 
               <icon name="home" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Dashboard  Utama</span> 
            </a> 
          </li>
           
           <li> 
            <a href="#/diklat/jp">
               <icon name="clock" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Capaian JP Pegawai</span> 
            </a> 
              
          </li>
          <li> 
            <a href="#/diklat/skj_formasi"> 
               <icon name="chart-bar" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Analisis SKJ & VS Formasi </span> 
            </a> 
          </li>
          
           <li class="nav-small-cap"> <span> E - Kompetensi  </span></li>
           <li> 
            <a href="#/diklat/ujikom"> 
               <icon name="clock" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Data Assesment / Ujikom </span> 
            </a> 
          </li>
          <li> 
            <a href="#/diklat/gap"> 
               <icon name="map" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Pemetaan Kompetensi </span> 
            </a> 
          </li>
          
           <li class="nav-small-cap"> <span> Pendidikan & Latihan</span></li>
           <li> 
            <a href="#/diklat/event"> 
               <icon name="calendar" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Kalender Kegiatan</span> 
            </a> 
          </li>
           <li> 
            <a href="#/diklat/Struktural"> 
               <icon name="document" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Diklat Struktural </span> 
            </a> 
          </li>
           
           <li> 
            <a href="#/diklat/fungsional"> 
               <icon name="document-duplicate" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Diklat Fungsional </span> 
            </a> 
          </li>
           <li> 
            <a href="#/diklat/teknis"> 
              <icon name="document-text" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Diklat Teknis </span> 
            </a> 
          </li>
           <li> 
            <a href="#/diklat/peminatan"> 
              <icon name="tag" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu">  Data Peminatan </span> 
            </a> 
          </li>
          <li> 
            <a href="#/diklat/arsip"> 
              <icon name="users" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Arsip Diklat pegawai </span> 
            </a> 
          </li>
          <!--
           <li> 
            <a href="#/diklat/sertifikasi"> 
              <icon name="video-camera" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu">Coaching / Mentoring </span> 
            </a> 
          </li>
        -->
          
         
          <li class="nav-small-cap"> <span> Data Master </span></li>
          <li> 
            <a href="#/diklat/master"> 
               <icon name="document-duplicate" class="md-size-1x mr-3  w-20"  />
              <span class="hide-menu"> Nama Diklat </span> 
            </a> 
          </li>

          
         
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
    //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
        menuItem : [] 
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations({
     // toggleDropdown: "toggleDropdown"
    }),
     toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    fetchData() {

            this.$store.dispatch('getData',{
                url :  'api/site/apimenu?f=vue' 
            }) .then(response => {
                 this.menuItem  = response.data.data
            }).catch((error) => {
                alert(error)
            }) 

       
    }
  }
};
</script>

<style scoped>
.collapse-sidebar {
  width: 70px;
}
.collapse-sidebar #sidebarnav > li > a.has-arrow:after {
  display: none;
}
.svg-inline--fa {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Diklat.vue